import React, { Component } from "react"
import config from "../../../helper/config"
import { customerConstants } from "../../../helper/constants.js"
import Modal from "react-bootstrap/Modal"
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates"
import ScreenSearchDesktopIcon from "@mui/icons-material/ScreenSearchDesktop"
import PostAddIcon from "@mui/icons-material/PostAdd"
import step1img1 from "../../../components/cmc/assets/images/steps/1_step 1.png"
import step1img2 from "../../../components/cmc/assets/images/steps/1_step 2 & 3.JPG"
import step2img1 from "../../../components/cmc/assets/images/steps/2_step 1.JPG"
import step2img2 from "../../../components/cmc/assets/images/steps/2_Step 2 & 3.JPG"
import step2img4 from "../../../components/cmc/assets/images/steps/2_step5.png"
import {
  estep1img1,
  estep1img2,
  estep1img3,
  estep2img1,
  estep2img2,
  estep2img3,
  estep2img4,
  estep2img5,
  estep2img6,
  estep2img7,
  estep2img8,
  estep2img9,
  estep2img10,
  estep2img11,
  estep2img12,
} from "../../../components/edsider/assets/images/Guidelines/guidelines.js"

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag
}

let isCMC,
  isEdSider,
  iconColor,
  subscriptionModal,
  searchPaperModal,
  stepsLabel,
  stepsBtn

const customer = getCustomerFeatureFlag()

switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    iconColor = "var(--maincolor)"
    isCMC = false
    isEdSider = true
    stepsLabel = {
      padding: "5px 10px",
      backgroundColor: "#f5f5ff",
      color: iconColor,
      fontWeight: "600",
      borderRadius: "5px",
      border: "1px solid #c8c9f9",
    }
    stepsBtn = {
      backgroundColor: iconColor,
      padding: "5px 10px",
      borderRadius: "3px",
      color: "#fff",
    }
    subscriptionModal = {
      step1img1: estep1img1,
      step1img2: estep1img2,
      step1img3: estep1img3,
    }
    searchPaperModal = {
      step2img1: estep2img1,
      step2img2: estep2img2,
      step2img3: estep2img3,
      step2img4: estep2img4,
      step2img5: estep2img5,
      step2img6: estep2img6,
      step2img7: estep2img7,
      step2img8: estep2img8,
      step2img9: estep2img9,
      step2img10: estep2img10,
      step2img11: estep2img11,
      step2img12: estep2img12,
    }
    break
  case customerConstants.EXO_CUSTOMER2:
    iconColor = "var(--maincolor-cmc)"
    isCMC = true
    isEdSider = false
    stepsLabel = {
      padding: "5px 10px",
      backgroundColor: "#eafaff",
      color: iconColor,
      fontWeight: "600",
      borderRadius: "5px",
      border: "1px solid #b3edff",
    }
    stepsBtn = {
      backgroundColor: iconColor,
      padding: "5px 10px",
      borderRadius: "3px",
      color: "#fff",
    }
    subscriptionModal = {
      step1img1: step1img1,
      step1img2: step1img2,
    }
    searchPaperModal = {
      step2img1: step2img1,
      step2img2: step2img2,
      step2img4: step2img4,
    }
    break
  default:
    iconColor = "var(--maincolor)"
    isCMC = false
    isEdSider = false
    stepsLabel = {
      padding: "5px 10px",
      backgroundColor: "#f5f5ff",
      color: iconColor,
      fontWeight: "600",
      borderRadius: "5px",
      border: "1px solid #c8c9f9",
    }
    stepsBtn = {
      backgroundColor: iconColor,
      padding: "5px 10px",
      borderRadius: "3px",
      color: "#fff",
    }
    subscriptionModal = {
      step1img1: estep1img1,
      step1img2: estep1img2,
      step1img3: estep1img3,
    }
    searchPaperModal = {
      step2img1: estep2img1,
      step2img2: estep2img2,
      step2img3: estep2img3,
      step2img4: estep2img4,
      step2img5: estep2img5,
      step2img6: estep2img6,
      step2img7: estep2img7,
      step2img8: estep2img8,
      step2img9: estep2img9,
      step2img10: estep2img10,
      step2img11: estep2img11,
      step2img12: estep2img12,
    }
    break
}

class QuickGuides extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isSearchPaperModalVisible: false,
      isBuyPaperModalVisible: false,
      featureFlag: getCustomerFeatureFlag(),
    }
  }

  toggleSearchPaperModal = () => {
    this.setState((prevState) => ({
      isSearchPaperModalVisible: !prevState.isSearchPaperModalVisible,
    }))
  }

  toggleBuyPaperModal = () => {
    this.setState((prevState) => ({
      isBuyPaperModalVisible: !prevState.isBuyPaperModalVisible,
    }))
  }

  render() {
    const { isBuyPaperModalVisible, isSearchPaperModalVisible } = this.state

    return (
      <>
        <div className="col-md-12 quickguide-container py-5 px-3 mt-5">
          <div className="row">
            <div className="col-md-12 d-flex align-items-center mb-5">
              <TipsAndUpdatesIcon sx={{ fontSize: "25px", color: "#ffbc04" }} />
              <h1 className="quickguide-heading m-0">Quick Guides</h1>
            </div>
            <button
              className="col-lg-4 col-md-6 col-12 d-flex align-items-center py-5 mr-2 mb-1 quickguide-content"
              onClick={this.toggleBuyPaperModal}
            >
              <PostAddIcon sx={{ fontSize: "20px", color: iconColor }} />
              <p className="pl-3 quickguide-text">How to do the Subscription</p>
            </button>
            <div
              className="col-lg-4 col-md-6 col-12 d-flex align-items-center py-5 mr-2 mb-1 quickguide-content"
              onClick={this.toggleSearchPaperModal}
            >
              <ScreenSearchDesktopIcon
                sx={{ fontSize: "20px", color: iconColor }}
              />
              <p className="pl-3 quickguide-text">How to Search Papers</p>
            </div>
          </div>
        </div>

        {/* Quick Guide - How to buy a paper modal */}
        <Modal
          size="lg"
          centered
          onHide={() => this.setState({ isBuyPaperModalVisible: false })}
          show={isBuyPaperModalVisible}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <PostAddIcon /> How to Buy a Paper?
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <p className="steps-content-text">
                First, you must purchase a credit package to buy papers
              </p>

              <p
                className="steps-text col-md-12 steps-label"
                style={stepsLabel}
              >
                Step 01
              </p>
              <p className="steps-content-text">
                <b>Subscriptions</b> menu {">"} Click the{" "}
                <span className="steps-btn mx-1" style={stepsBtn}>
                  Add Credits
                </span>{" "}
                Button
              </p>
              <img
                src={subscriptionModal.step1img1}
                alt="step-1"
                className="pb-5"
              />

              <p
                className="steps-text col-md-12 steps-label"
                style={stepsLabel}
              >
                Step 02
              </p>
              <p className="steps-content-text">
                Select the <b>Level Price</b> & the <b>Type</b>
              </p>

              <p
                className="steps-text col-md-12 steps-label"
                style={stepsLabel}
              >
                Step 03
              </p>
              <p className="steps-content-text">
                Click the{" "}
                <span className="steps-btn mx-1" style={stepsBtn}>
                  Pay
                </span>{" "}
                Button {">"} Will Direct you to the <b>Payment Gateway</b>
                {">"} Make the Payment
              </p>
              <img
                src={subscriptionModal.step1img2}
                alt="step-2&3"
                className="pb-5"
              />

              {isEdSider && (
                <>
                  <p
                    className="steps-text col-md-12 steps-label"
                    style={stepsLabel}
                  >
                    Step 04
                  </p>
                  <p className="steps-content-text col-md-12">
                    You will receive a payment confirmation mail
                  </p>
                  <img
                    src={subscriptionModal.step1img3}
                    alt="step-4"
                    className="pb-5"
                    style={{ width: "350px", height: "auto" }}
                  />
                </>
              )}
            </div>
          </Modal.Body>
        </Modal>

        {/* Quick Guide - How to search paper modal */}
        <Modal
          size="lg"
          centered
          onHide={() => this.setState({ isSearchPaperModalVisible: false })}
          show={isSearchPaperModalVisible}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <ScreenSearchDesktopIcon /> How to Search Papers?
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              {/* Step 01 */}
              <p
                className="steps-text col-md-12 steps-label"
                style={stepsLabel}
              >
                Step 01
              </p>
              <p className="steps-content-text">
                <b>Papers</b> menu item {">"} <b>Paper list</b> tab {">"} Select
                a paper and click the{" "}
                <span className="steps-btn mx-1" style={stepsBtn}>
                  Enroll
                </span>{" "}
                Button
              </p>
              <img
                src={searchPaperModal.step2img1}
                alt="step-1"
                className="pb-5"
              />

              {/* Step 02 */}
              <p
                className="steps-text col-md-12 steps-label"
                style={stepsLabel}
              >
                Step 02
              </p>
              <p className="steps-content-text">
                Select an <b>Available Credit Package</b>
              </p>

              {/* Step 03 */}
              {isCMC ? (
                <>
                  <p
                    className="steps-text col-md-12 steps-label"
                    style={stepsLabel}
                  >
                    Step 03
                  </p>
                  <p className="steps-content-text">
                    Click the{" "}
                    <span className="steps-btn mx-1" style={stepsBtn}>
                      Enroll
                    </span>{" "}
                    button & Confirm
                  </p>
                  <img
                    src={searchPaperModal.step2img2}
                    alt="step-2&3"
                    className="pb-5"
                    style={{ width: "550px", height: "auto" }}
                  />
                </>
              ) : (
                <>
                  <p
                    className="steps-text col-md-12 steps-label"
                    style={stepsLabel}
                  >
                    Step 03
                  </p>
                  <p className="steps-content-text col-md-12">
                    Click the{" "}
                    <span className="steps-btn mx-1" style={stepsBtn}>
                      Enroll
                    </span>{" "}
                    button & Confirm
                  </p>
                  <img
                    src={searchPaperModal.step2img2}
                    alt="step-3"
                    className="pb-5"
                    style={{ width: "350px", height: "auto" }}
                  />
                  <img
                    src={searchPaperModal.step2img3}
                    alt="step-3"
                    className="pb-5"
                    style={{ width: "350px", height: "auto" }}
                  />
                </>
              )}

              {/* Step 04 */}
              {isCMC && (
                <>
                  <p
                    className="steps-text col-md-12 steps-label"
                    style={stepsLabel}
                  >
                    Step 04
                  </p>
                  <p className="steps-content-text col-md-12">
                    <b>Enrolled Papers</b> tab {">"} Track the Status of the
                    Enrolled Papers & Take the Exam
                  </p>
                  <img
                    src={searchPaperModal.step2img4}
                    alt="step-2&3"
                    className="pb-5"
                  />
                </>
              )}

              {isEdSider && (
                <div>
                  {/* Scenario 01 */}
                  <p className="col-md-12 my-4 stu-variant-class label label-lg label-light-warning label-inline">
                    Scenario 01
                  </p>
                  <p
                    className="steps-text col-md-12 steps-label"
                    style={stepsLabel}
                  >
                    (Without parent involvement) Student Self-Enrollment
                  </p>
                  <p className="steps-content-text col-md-12">
                    Enroll by Student {">"} Immediate Approval
                  </p>
                  <img
                    src={searchPaperModal.step2img4}
                    alt="scenario 01"
                    className="pb-5"
                    style={{ width: "350px", height: "auto" }}
                  />

                  {/* Scenario 02 */}
                  <p className="col-md-12 my-4 stu-variant-class label label-lg label-light-warning label-inline">
                    Scenario 02
                  </p>
                  <p
                    className="steps-text col-md-12 steps-label"
                    style={stepsLabel}
                  >
                    (With parent involvement) Student Self-Enrollment
                  </p>
                  <img
                    src={searchPaperModal.step2img5}
                    alt="scenario 01"
                    className="pb-5"
                    style={{ width: "350px", height: "auto" }}
                  />
                  <p className="steps-content-text col-md-12">
                    Enroll by Student {">"} Parent receives Approval Email
                  </p>
                  <img
                    src={searchPaperModal.step2img6}
                    alt="scenario 01"
                    className="pb-5"
                    style={{ width: "350px", height: "auto" }}
                  />
                  <p className="steps-content-text col-md-12">
                    Student receives the confirmation and the paper status will change
                    from <b>Pending</b> to <b>Approved</b>
                  </p>
                  <img
                    src={searchPaperModal.step2img7}
                    alt="scenario 01"
                    className="pb-5"
                    style={{ width: "350px", height: "auto" }}
                  />

                  {/* Scenario 03 */}
                  <p className="col-md-12 my-4 stu-variant-class label label-lg label-light-warning label-inline">
                    Scenario 03
                  </p>
                  <p
                    className="steps-text col-md-12 steps-label"
                    style={stepsLabel}
                  >
                    (With parent involvement) Parent Enrollment
                  </p>
                  <p className="steps-content-text col-md-12">
                    <b>Papers</b> menu item {">"} <b>Paper List</b> tab
                  </p>

                  {/* Scenario 03 - Step 01 */}
                  <div className="row d-flex px-0">
                    <div className="col-md-2 px-0">
                      <p
                        className="stu-variant-class label label-lg label-light label-inline"
                      >
                        Step 01
                      </p>
                    </div>
                    <div className="col-md-10 px-0">
                      <p className="py-0 steps-content-text col-md-12">
                        Parent can select the child
                      </p>
                    </div>
                  </div>
                  <img
                    src={searchPaperModal.step2img8}
                    alt="scenario 01"
                    className="pb-5 pt-3"
                  />

                  {/* Scenario 03 - Step 02 */}
                  <div className="row d-flex px-0">
                    <div className="col-md-2 px-0">
                    <p
                      className="stu-variant-class label label-lg label-light label-inline"
                    >
                      Step 02
                    </p>
                    </div>
                    <div className="col-md-10 px-0">
                      <p className="py-0 steps-content-text col-md-12">
                        Click the <span>Enroll</span> button (Follow the above same
                        steps on selecting an Available Credit Pckage and Enrollment
                        Confirmation)
                      </p>
                    </div>
                  </div>
                  <img
                    src={searchPaperModal.step2img9}
                    alt="scenario 01"
                    className="py-5"
                    style={{ width: "350px", height: "auto" }}
                  />

                  {/* Scenario 03 - Step 03 */}
                  <div className="row d-flex px-0">
                    <div className="col-md-2 px-0">
                      <p
                        className="stu-variant-class label label-lg label-light label-inline"
                      >
                        Step 03
                      </p>
                    </div>
                    <div className="col-md-10 px-0">
                      <p className="py-0 steps-content-text col-md-12">
                        Parent will receive the Approval Email
                      </p>
                    </div>
                  </div>
                  <img
                    src={searchPaperModal.step2img6}
                    alt="scenario 01"
                    className="py-5"
                    style={{ width: "350px", height: "auto" }}
                  />

                  {/* Scenario 03 - Step 04 */}
                  <div className="row d-flex px-0">
                    <div className="col-md-2 px-0">
                      <p
                        className="stu-variant-class label label-lg label-light label-inline"
                      >
                        Step 04
                      </p>
                    </div>
                    <div className="col-md-10 px-0">
                      <p className="py-0 steps-content-text col-md-12">
                        The student will receive a Confirmation Email on their
                        parent enrollment
                      </p>
                    </div>
                  </div>
                  <img
                    src={searchPaperModal.step2img11}
                    alt="scenario 01"
                    className="py-5"
                    style={{ width: "350px", height: "auto" }}
                  />

                  <p
                    className="steps-text col-md-12 steps-label"
                    style={stepsLabel}
                  >
                    Step 04
                  </p>
                  <p className="steps-content-text col-md-12">
                    <b>Enrolled Papers</b> tab {">"} Track the status of the
                    papers and take the exam
                  </p>
                  <img
                    src={searchPaperModal.step2img12}
                    alt="scenario 01"
                    className="pb-5"
                  />
                </div>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </>
    )
  }
}

export default QuickGuides
